import { default_dashboard } from '@core/breadcrumbs';

export const pbx_module_breadcrumbs = default_dashboard
  .extend('pbx.module')
  .add('pbx.breadcrumb.title', { name: 'pbx.module' });
